module.exports = __webpack_public_path__ + "img/7.a6173ade.png";